<template>
  <div class="add-basic-information">
    <div class="add-title">
      <span class="basic title-font-style">联系人信息</span>
      <div class="save">
        <el-button v-if="isEdit" type="primary" plain @click="onAddLinkman">添加联系人</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&isEdit"
          @click="onSave"
        >保存</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&!isEdit"
          @click="onDetail"
        >编辑</el-button>
      </div>
    </div>
    <div
      v-for="(item,index) in queryParams"
      :key="index"
      class="add-content"
      style="padding-left:50px;padding-bottom:10px"
    >
      <el-form
        :model="item"
        class="demo-form-inline"
        :label-width="!isEdit ? '': '95px'"
        ref="queryParamsRefs"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-col :span="20" style="padding:0px;">
              <el-form-item
                label="联系人："
                prop="ccContacts"
                :rules="filter_rules({required:true,prop:'ccContacts'})"
              >
                <el-input v-if="isEdit" v-model="item.ccContacts"></el-input>
                <span v-else>{{item.ccContacts}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="text-align:right;">
              <el-form-item label-width="0px">
                <el-button v-if="item.isDefault === true" size="mini" class="main-contact">主联系人</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系电话："
              prop="ccPhone"
              :rules="filter_rules({required:true,trigger:['change','blur']})"
            >
              <el-input v-if="isEdit" v-model="item.ccPhone" @input.native="onInput"></el-input>
              <span v-else>{{item.ccPhone||'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系手机：">
              <el-input v-if="isEdit" v-model="item.ccMobile" @input.native="onInput"></el-input>
              <span v-else>{{item.ccMobile||'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="传真号码：">
              <el-input v-if="isEdit" v-model="item.ccFax"></el-input>
              <span v-else>{{item.ccFax||'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱地址：">
              <el-input v-if="isEdit" v-model="item.ccMail"></el-input>
              <span v-else>{{item.ccMail||'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="QQ号码：">
              <el-input v-if="isEdit" v-model="item.ccQq"></el-input>
              <span v-else>{{item.ccQq||'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="生日：">
              <el-input v-if="isEdit" v-model="item.ccBirthday"></el-input>
              <span v-else>{{item.ccBirthday ||'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注：">
              <el-input v-if="isEdit" v-model="item.mark"></el-input>
              <span v-else>{{item.mark||'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!item.isDefault">
          <el-col style="text-align:right;margin-bottom:10px;">
            <el-button v-if="!item.isDefault" @click="onDelete(item,index)">删除</el-button>
            <el-button
              @click="onMainLinkman(item,index)"
              v-if="!item.isDefault"
              plain
              type="primary"
            >设为主联系人</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  updateCustomerConnect,
  customerConnectDelete,
  customerConnectUpdateByIsDefault
} from '@/api/customer/customerManage'
import {
  supplierConnectUpdateById,
  supplierConnectDelete,
  supplierConnectUpdateByIsDefault
} from '@/api/supplier/supplierManage'
export default {
  props: ['isShow', 'contactInformation'],
  data() {
    return {
      queryParams: [
        {
          isDefault: true,
          id: '',
          cbId: '',
          flag: true
        }
      ],
      isEdit: false
    }
  },
  watch: {
    contactInformation(val, oldVal) {
      if (this.$route.path === '/crm/supplier/supplierEdit') {
        // 供应商联系人编辑参数转换
        const supplierLinkManList = []
        this.contactInformation.forEach(item => {
          const paramsLink = {
            // 联系人信息
            flag: item.flag,
            id: item.id,
            isDefault: item.isDefault,
            mark: item.mark,
            ccBirthday: item.suBirthday,
            ccContacts: item.suContacts,
            ccFax: item.suFax,
            cbId: item.suId,
            ccMail: item.suMail,
            ccMobile: item.suMobile,
            ccPhone: item.suPhone,
            ccQq: item.suQq
          }
          if (paramsLink.isDefault) {
            supplierLinkManList.unshift(paramsLink)
          } else {
            supplierLinkManList.push(paramsLink)
          }
        })
        this.queryParams = supplierLinkManList
      } else if (this.$route.path === '/crm/customer/details') {
        this.queryParams = this.contactInformation
      }
    }
  },
  mounted() {
    this.isEdit = this.isShow
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    onDeleteUpdate(item, index) {
      this.queryParams.splice(index, 1)
    },
    // 添加联系人
    onAddLinkman() {
      if (
        this.$route.path === '/crm/customer/details' ||
        this.$route.path === '/crm/supplier/supplierEdit'
      ) {
        // 编辑详情添加联系人
        const params = {
          isDefault: false,
          cbId: this.$route.query.id,
          flag: true
        }
        this.queryParams.push(params)
      } else {
        // 添加供应商添加联系人
        const params = { isDefault: false, flag: true }
        this.queryParams.push(params)
      }
    },
    // 删除联系人
    onDelete(val, index) {
      if (this.queryParams.length > 1) {
        // 客户管理,供应商管理添加中的删除
        if (
          this.$route.path === '/crm/customer/addCustomers' ||
          this.$route.path === '/crm/supplier/supplierAdd'
        ) {
          if (val.isDefault === true) {
            this.queryParams.splice(index, 1)
            this.queryParams[0].isDefault = true
          } else {
            this.queryParams.splice(index, 1)
          }
        } else {
          // 客户管理,供应商管理详情联系人删除
          if (val.id) {
            if (this.$route.path === '/crm/customer/details') {
              // 客户详情删除联系人
              this.getCustomerConnectDelete(val.id, index)
            } else if (this.$route.path === '/crm/supplier/supplierEdit') {
              // 供应商详情删除联系人
              this.getSupplierConnectDelete(val.id, index)
            }
          } else {
            // 没有保存的数据删除
            this.queryParams.splice(index, 1)
          }
        }
      } else {
        this.$message.error('联系人必须保留一个!')
      }
    },
    // 根据客户联系人id删除联系人
    getCustomerConnectDelete(id, index) {
      customerConnectDelete(id)
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach(item => {
              // 根据返回的id设置主联系人
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 根据供应商联系人id删除联系人
    getSupplierConnectDelete(id, index) {
      supplierConnectDelete(id)
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach(item => {
              // 根据返回的id设置主联系人
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设为主联系人
    onMainLinkman(row, index) {
      if (row.id) {
        if (this.$route.path === '/crm/customer/details') {
          // 客户详情设为主联系人
          customerConnectUpdateByIsDefault(row.id, row.cbId)
            .then(res => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主联系人')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
                console.log('====>1', this.queryParams[index])
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else if (this.$route.path === '/crm/supplier/supplierEdit') {
          // 供应商详情设为主联系人
          supplierConnectUpdateByIsDefault(row.id, row.cbId)
            .then(res => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主联系人')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      } else {
        // 客户管理和供应商管理添加设为主联系人
        for (let i = 0; i < this.queryParams.length; i++) {
          if (i === index) {
            this.queryParams[i].isDefault = true
          } else {
            this.queryParams[i].isDefault = false
          }
        }
        this.queryParams.unshift(this.queryParams[index])
        this.queryParams.splice(index + 1, 1)
      }
    },
    // 保存
    onSave() {
      if (!this.onLinkmanRules()) {
        return
      }
      if (this.$route.path === '/crm/customer/details') {
        // 客户管理保存
        let isParams = false
        this.queryParams.forEach(element => {
          if ((!element.ccContacts || !element.ccPhone.length) && !isParams) {
            this.$message.error('必填项不能为空')
            isParams = true
          }
        })
        if (!isParams) {
          const supplierLinkManList = []
          this.queryParams.forEach(item => {
            const paramsLink = {
              // 联系人信息
              flag: item.flag,
              id: item.id,
              isDefault: item.isDefault,
              mark: item.mark,
              ccBirthday: item.ccBirthday,
              ccContacts: item.ccContacts,
              ccFax: item.ccFax,
              cbId: item.cbId,
              ccMail: item.ccMail,
              ccMobile: item.ccMobile,
              ccPhone: item.ccPhone,
              ccQq: item.ccQq
            }
            supplierLinkManList.push(paramsLink)
          })

          updateCustomerConnect(this.queryParams)
            .then(res => {
              if (res.data.code === 200) {
                this.queryParams = res.data.obj
                this.$message.success('保存成功!')
                this.isEdit = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      } else if (this.$route.path === '/crm/supplier/supplierEdit') {
        // 供应商保存
        let isParams = false
        this.queryParams.forEach(element => {
          if ((!element.ccContacts || !element.ccPhone.length) && !isParams) {
            this.$message.error('必填项不能为空')
            isParams = true
          }
        })
        if (!isParams) {
          const supplierLinkManList = []
          this.queryParams.forEach(item => {
            const paramsLink = {
              // 联系人信息
              flag: item.flag,
              id: item.id,
              isDefault: item.isDefault,
              mark: item.mark,
              suBirthday: item.ccBirthday,
              suContacts: item.ccContacts,
              suFax: item.ccFax,
              suId: item.cbId,
              suMail: item.ccMail,
              suMobile: item.ccMobile,
              suPhone: item.ccPhone,
              suQq: item.ccQq
            }
            supplierLinkManList.push(paramsLink)
          })
          supplierConnectUpdateById(supplierLinkManList)
            .then(res => {
              if (res.data.code === 200) {
                const supplierLinkManList = []
                res.data.obj.forEach(item => {
                  // 拿到保存后的数组重新赋值
                  const paramsLink = {
                    // 联系人信息
                    flag: item.flag,
                    id: item.id,
                    isDefault: item.isDefault,
                    mark: item.mark,
                    ccBirthday: item.suBirthday,
                    ccContacts: item.suContacts,
                    ccFax: item.suFax,
                    cbId: item.suId,
                    ccMail: item.suMail,
                    ccMobile: item.suMobile,
                    ccPhone: item.suPhone,
                    ccQq: item.suQq
                  }
                  if (paramsLink.isDefault) {
                    supplierLinkManList.unshift(paramsLink)
                  } else {
                    supplierLinkManList.push(paramsLink)
                  }
                })
                this.$message.success('保存成功!')
                this.isEdit = false
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    // 编辑
    onDetail() {
      this.isEdit = true
    },
    // 联系人校验
    onLinkmanRules() {
      let isF = true
      this.$refs.queryParamsRefs[0].validate((valid) => {
        if (valid) {
          isF = true
        } else {
          isF = false
        }
      })
      this.$emit('onParent', isF)
      return isF
      // let isF = false
      // this.queryParams.forEach(ele => {
      //   if (!ele.ccContacts || !ele.ccPhone) {
      //     isF = true
      //   }
      // })
    }
  }
}
</script>
